<template>
  <v-input
    :value="value"
    v-bind="$attrs"
  >
    <div class="rating">
      <template v-for="i in (maxVal - minVal + 1)">
        <Ratio
          v-if="!inverted"
          :on-color="onColor"
          :off-color="offColor"
          :is-checked="current_val == i"
          :is-bordered="altValue == i"
          :border-color="altColor"
          :label="i.toString()"
          :key="i"
          @click="select(i)"
        />
        <Ratio
          v-else
          :on-color="onColor"
          :off-color="offColor"
          :is-checked="altValue == i"
          :is-bordered="current_val == i"
          :border-color="altColor"
          :label="i.toString()"
          :key="i"
          @click="select(i)"
        />
      </template>
    </div>
  </v-input>
</template>
<script>
import Ratio from "@/components/Ratio.vue";

export default {
  name: "RatingInput",
  components: {
    Ratio
  },
  props: {
    minVal: {
      type: Number,
      required: false,
      default: 1
    },
    maxVal: {
      type: Number,
      required: false,
      default: 10
    },
    onColor: {
      type: String,
      required: false,
      default: ""
    },
    offColor: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: Number,
      required: false,
      default: undefined
    },
    altValue: {
      type: Number,
      required: false,
      default: undefined,
    },
    altColor: {
      type: String,
      required: false,
      default: undefined,
    },
    inverted: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      current_val: undefined,
      current_alt_val: undefined,
    }
  },
  mounted() { this.current_val = this.value; },
  watch: {
    value(newVal) {
      this.current_val = newVal;
    }
  },
  methods: {
    select(index) {
      this.current_val = index;
      this.change();
    },
    change() {
      this.$emit('input', this.current_val);
    }
  }
}
</script>
<style lang="scss">
.rating {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}
</style>
